export default __webpack_public_path__ + "static/media/white_close_icon.218fff07.svg";